const dev = {
  API_URL: "https://localhost:3000/api",
  REPORT_URL: "https://localhost:3000/reports",
  AUTH_URL: "https://localhost:3000",
  TOKEN_KEY: "ekauth:token",
  REFRESH_KEY: "ekauth:refreshToken",
  EXP_KEY: "ekauth:expiryDate",
  USER_INFO: "ekauth:user"
}

const test = {
  API_URL: "http://srv.gruporecover.com:8002/api",
  REPORT_URL: "https://srv.gruporecover.com:8002/reports",
  AUTH_URL: "http://srv.gruporecover.com:8002",
  TOKEN_KEY: "auth:token",
  REFRESH_KEY: "auth:refreshToken",
  EXP_KEY: "auth:expiryDate",
  USER_INFO: "auth:user",
}

const prod = {
  API_URL: "https://app.mra-legal.com:8002/api",
  REPORT_URL: "https://app.mra-legal.com:8002/reports",
  AUTH_URL: "https://app.mra-legal.com:8002",
  TOKEN_KEY: "auth:token",
  REFRESH_KEY: "auth:refreshToken",
  EXP_KEY: "auth:expiryDate",
  USER_INFO: "auth:user"
}

export const selectVariables = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return prod
    case 'test':
    case 'stage':
      return test
    default:
      return dev
  }
}

export const TYPES = {
  APP_INIT: "APP_INIT",
  APP_SET_USER: "APP_SET_USER",
  APP_SET_HEADER: "APP_SET_HEADER",
  AUTH_REQUEST: "AUTH_REQUEST",
  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_FAILURE: "AUHT_FAILURE",
  AUTH_CLEAN: "AUTH_CLEAN",
  AUTH_SET_TOKEN: "AUTH_SET_TOKEN",
  FETCH_DATA: "FETCH_DATA",
  SAVE_DATA: "SAVE_DATA",
  PUT_DATA: "PUT_DATA",
  UPDATE_DATA: "UPDATE_DATA",
  DELETE_DATA: "DELETE_DATA"
}


const statusColors = {
  new: "#8B5CF6",
  info: "#0EA5E9",
  success: "#166132ff",
  successSoft: "#65A30D",
  warning: "#F59E0B",
  danger: "#DC2626",
  dangerSoft: "#EA580C",
  neutral: "#6B7280",
  closed: "#374151",
  blocked: "#7C2D12"
}

//----------------------------------
// CASE
//----------------------------------

export const caseColor = s => {
  switch (s) {
    case "nuevo":
      return statusColors.new
    case "sin_movimiento":
      return statusColors.neutral
    case "cerrado":
      return statusColors.closed
    case "anulado":
      return statusColors.danger
    case "para_facturar":
      return statusColors.warning
    case "bloqueado":
      return statusColors.blocked
    case "solicitado":
      return statusColors.info
    case "solicitado_parcial":
      return statusColors.successSoft
    default:
      return statusColors.neutral
  }
}

export const caseState = [
  { text: 'Nuevo', value: 0 },
  { text: 'Sin Movimiento', value: 1 },
  { text: 'Cerrado', value: 2 },
  { text: 'Anulado', value: 3 },
  { text: 'Para Facturar', value: 5 },
  { text: 'Bloqueado', value: 7 },
  { text: "Solicitado", value: 8 },
  { text: "Solicitado Parcial", value: 9 }
]

//----------------------------------
// STAMP
//----------------------------------

export const stampColor = s => {
  switch (s) {
    case "entregado":
      return statusColors.success
    case "devuelto":
      return statusColors.neutral
    case "solicitado":
      return statusColors.info
    case "atrasado":
      return statusColors.dangerSoft
    default:
      return statusColors.neutral
  }
}

export const stampState = [
  { text: 'Solicitado', value: 1 },
  { text: 'Entregado', value: 2 },
  { text: 'Devuelto', value: 3 },
  { text: 'Atrasado', value: 4 }
]


//----------------------------------
// FEE
//----------------------------------

export const feeColor = s => {
  switch (s) {
    case "pagado":
      return statusColors.success
    case "cobrando":
      return statusColors.successSoft
    case "anulado":
      return statusColors.neutral
    case "pendiente_pago":
      return statusColors.warning
    default:
      return statusColors.neutral
  }
}

export const feeState = [
  { text: 'Pendiente Pago', value: 1 },
  { text: 'Anulado', value: 3 },
  { text: 'Cobrando', value: 4 },
  { text: 'Pagado', value: 5 }
]

//----------------------------------
// EXPENSE
//----------------------------------

export const expenseColor = s => {
  switch (s) {
    case "nuevo":
      return statusColors.new
    case "pagado":
      return statusColors.success
    case "cobrado":
      return statusColors.dangerSoft
    case "anulado":
      return statusColors.neutral
    case "pendiente_pago":
      return statusColors.warning
    case "solicitado":
      return statusColors.info
    default:
      return statusColors.neutral
  }
}

export const expenseState = [
  { text: 'Nuevo', value: 0 },
  { text: 'Pendiente de Pago', value: 1 },
  { text: 'Solicitado', value: 2 },
  { text: 'Anulado', value: 3 },
  { text: 'Cobrado', value: 4 },
  { text: 'Pagado', value: 5 }
]


export const expenseOfficeState = [
  { text: 'Nuevo', value: 0 },
  { text: 'Pendiente de Pago', value: 1 },
  { text: 'Anulado', value: 3 },
  { text: 'Cobrado', value: 4 },
  { text: 'Pagado', value: 5 }
]


//----------------------------------
// EXPENSE REQUEST
//----------------------------------

export const expenseRequestColor = s => {
  switch (s) {
    case "liquidado":
      return statusColors.successSoft
    case "liquidado_parcial":
      return statusColors.successSoft
    case "anulado":
      return statusColors.danger
    case "pendiente":
      return statusColors.warning
    case "nuevo":
      return statusColors.new
    case "solicitado":
      return statusColors.info
    case "aprobado":
      return statusColors.success
    default:
      return statusColors.neutral
  }
}

export const expenseRequestState = [
  { text: 'Liquidado Confia', value: 0 },
  { text: 'Solicitado', value: 1 },
  { text: 'Nuevo', value: 2 },
  { text: 'Aprobado', value: 3 },
  { text: 'Liquidado Parcial', value: 4 },
  { text: 'Liquidado', value: 5 },
  { text: 'Anulado', value: 6 },
  { text: 'Pendiente', value: 7 }
]


//----------------------------------
// REQUEST
//----------------------------------

export const requestColor = s => {
  switch (s) {
    case "nuevo":
      return statusColors.new
    case "aprobado":
      return statusColors.success
    case "procesando":
      return statusColors.info
    case "cerrado":
      return statusColors.closed
    case "cancelado":
      return statusColors.danger
    default:
      return statusColors.neutral
  }
}

export const requestState = [
  { text: 'Nuevo', value: 0 },
  { text: 'Aprobado', value: 1 },
  { text: 'Procesando', value: 2 },
  { text: 'Cerrado', value: 3 },
  { text: 'Cancelado', value: 5 }
]

export const requestType = [
  { text: 'Factura', value: 1 },
  { text: 'Factura Exportación', value: 2 },
  { text: 'Recibo Gastos', value: 0 },
]

export const typeColor = s => {
  switch (s) {
    case 0:
      return "#c7afaf"
    case 1:
      return "#acbe87"
    case 2:
      return "#a7c9f8"
    default:
      return ""
  }
}

//----------------------------------
// INVOICE
//----------------------------------

export const invoiceColor = s => {
  switch (s) {
    case "nuevo":
      return statusColors.new
    case "emitido":
      return statusColors.info
    case "pagado":
      return statusColors.success
    case "anulado":
      return statusColors.danger
    case "anulado_ncre":
      return statusColors.danger
    default:
      return statusColors.neutral
  }
}


export const invoiceTypeColor = s => {
  switch (s) {
    case "fact":
      return statusColors.success
    case "ncre":
      return statusColors.dangerSoft
    case "ndeb":
      return statusColors.danger
    case "nabn":
      return statusColors.closed
    case "fexp":
      return statusColors.info
    default:
      return statusColors.neutral
  }
}

export const invoiceState = [
  { text: 'Nuevo', value: 0 },
  { text: 'Emitido', value: 1 },
  { text: 'Pagado', value: 2 },
  { text: 'Anulado', value: 5 },
  { text: 'Anulado NCRE', value: 6 }
]

export const invoiceType = [
  { text: "Factura", value: 0 },
  { text: "Nota de Crédito", value: 1 },
  { text: "Nota de Débito", value: 2 },
  { text: "Nota de Abono", value: 3 },
  { text: "Factura Exportación", value: 4 }
]

//----------------------------------
// PAYMENT
//----------------------------------

export const paymentColor = s => {
  switch (s) {
    case "tramite":
      return statusColors.new
    case "liquidado":
      return statusColors.success
    case "pagado":
      return statusColors.successSoft
    case "para_liquidar":
      return statusColors.warning
    case "anulado":
      return statusColors.danger
    default:
      return statusColors.neutral
  }
}

export const paymentMethodColor = s => {
  switch (s) {
    case "transaccion":
      return statusColors.info
    case "deposito":
      return statusColors.new
    case "cheque":
      return statusColors.success
    case "efectivo":
      return statusColors.neutral
    default:
      return statusColors.neutral
  }
}

export const paymentState = [
  { text: 'Tramite', value: 0 },
  { text: 'Liquidado', value: 1 },
  { text: 'Para Liquidar', value: 2 },
  { text: 'Anulado', value: 3 },
  { text: 'Pagado', value: 4 }
]

export const paymentMethod = [
  { text: 'Transaccion', value: 0, label: "Transaccion" },
  { text: 'Deposito', value: 1, label: "Deposito" },
  { text: 'Cheque', value: 2, label: "Cheque" },
  { text: 'Efectivo', value: 3, label: "Efectivo" }
]

export const paymentDirection = [
  { text: 'Saliente', value: 0 },
  { text: 'Entrante', value: 1 }
]

//----------------------------------
// RECEIPT
//----------------------------------

export const receiptColor = s => {
  switch (s) {
    case "aplicado":
      return statusColors.success
    case "disponible":
      return statusColors.info
    case "parcial":
      return statusColors.warning
    default:
      return statusColors.neutral
  }
}

export const receiptType = [
  { text: 'Pago Factura', value: 0, label: "Pago Factura" },
  { text: 'Adelanto', value: 1, label: "Adelanto" },
]

export const receiptState = [
  { text: 'Aplicado', value: 0, label: "Aplicado" },
  { text: 'Parcial', value: 1, label: "Parcial" },
  { text: 'Disponible', value: 2, label: "Disponible" }
]

//----------------------------------
// NOTE
//----------------------------------

export const noteColor = s => {
  switch (s) {
    case "nuevo":
      return statusColors.new
    case "pagado":
      return statusColors.success
    default:
      return statusColors.neutral
  }
}

export const noteState = [
  { text: 'Nuevo', value: 0 },
  { text: 'Pagado', value: 1 }
]

//----------------------- TO ->

export const statusColor = s => {
  const map = {
    nuevo: statusColors.new,
    solicitado: statusColors.info,
    procesando: statusColors.info,
    emitido: statusColors.info,
    pendiente: statusColors.warning,
    pendiente_pago: statusColors.warning,
    para_facturar: statusColors.warning,
    aprobado: statusColors.success,
    pagado: statusColors.success,
    liquidado: statusColors.success,
    entregado: statusColors.success,
    cerrado: statusColors.closed,
    liquidado_parcial: statusColors.successSoft,
    solicitado_parcial: statusColors.successSoft,
    cobrando: statusColors.successSoft,
    atrasado: statusColors.dangerSoft,
    bloqueado: statusColors.blocked,
    anulado: statusColors.danger,
    cancelado: statusColors.danger,
    anulado_ncre: statusColors.danger,
    sin_movimiento: statusColors.neutral,
    devuelto: statusColors.neutral
  }
  return map[s] || statusColors.neutral
}

export const stateSnake = s => s.split("_").map(w => w.toUpperCase()).join(" ")

export const write_access = ['master', 'admin']

export const VARS = selectVariables()
